import { AccordionGroup } from './group';
import { AccordionSingle } from './single';

export const Accordion = {
  Group: AccordionGroup,
  Single: AccordionSingle,
};
